export const CONDICIONES_PAGO_OPTS = [
  "Contado",
  "50% anticipo / 50% contra entrega",
  "60% anticipo / 40% contra entrega",
  "Crédito 15 días",
  "Crédito 30 días",
  "Crédito 60 días",
  "Crédito 90 días",
  "Pago contra entrega",
];

export const TIEMPO_ENTREGA_OPTS = [
  "Inmediata",
  "1 día",
  "3 días hábiles",
  "5 días hábiles",
  "7 días hábiles",
  "10 días hábiles",
  "15 días hábiles",
  "30 días hábiles",
];

export const safeText = (v, fallback = "") =>
  v === undefined || v === null || `${v}`.trim() === "" ? fallback : `${v}`;

export const addDays = (date, days) => {
  const d = new Date(date);
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() + Number(days || 0));
  return d;
};

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
